import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import {ThemeProvider} from './contexts/ThemeContext';
import {AuthProvider} from './contexts/AuthContext';
import {LocationProvider} from './contexts/LocationContext';
import {MenuProvider} from './contexts/MenuContext';
import {OrderProvider} from './contexts/OrderContext';
import {PaymentProvider} from './contexts/PaymentContext';
import {PrinterProvider} from './contexts/PrinterContext';
import LandingPage from './components/LandingPage';
import LegalPage from './components/sections/LegalPage';
import Login from './components/admin/Login';
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './components/admin/Dashboard';
import ThemeSettings from './components/admin/ThemeSettings';
import UserManagement from './components/admin/UserManagement';
import LocationManagement from './components/admin/LocationManagement';
import CategoryManagement from './components/admin/CategoryManagement';
import MenuManagement from './components/admin/MenuManagement';
import OrderManagement from './components/admin/OrderManagement';
import KitchenDisplayFull from './components/kitchen/KitchenDisplayFull';
import KitchenDisplay from './components/admin/KitchenDisplay';
import PaymentSettings from './components/admin/PaymentSettings';
import PrinterSettings from './components/admin/PrinterSettings';
import Settings from './components/admin/Settings';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <PaymentProvider>
          <PrinterProvider>
            <OrderProvider>
              <MenuProvider>
                <ThemeProvider>
                  <Router>
                    <div className="App">
                      <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/menu" element={<Navigate to="/" replace />} />
                        <Route path="/terms-of-use" element={<LegalPage type="terms" />} />
                        <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/admin" element={<AdminLayout><Dashboard /></AdminLayout>} />
                        <Route path="/admin/theme" element={<AdminLayout><ThemeSettings /></AdminLayout>} />
                        <Route path="/admin/users" element={<AdminLayout><UserManagement /></AdminLayout>} />
                        <Route path="/admin/locations" element={<AdminLayout><LocationManagement /></AdminLayout>} />
                        <Route path="/admin/categories" element={<AdminLayout><CategoryManagement /></AdminLayout>} />
                        <Route path="/admin/menu" element={<AdminLayout><MenuManagement /></AdminLayout>} />
                        <Route path="/admin/orders" element={<AdminLayout><OrderManagement /></AdminLayout>} />
                        <Route path="/admin/kitchen" element={<AdminLayout><KitchenDisplay /></AdminLayout>} />
                        <Route path="/kitchen" element={<KitchenDisplayFull />} />
                        <Route path="/admin/payments" element={<AdminLayout><PaymentSettings /></AdminLayout>} />
                        <Route path="/admin/printers" element={<AdminLayout><PrinterSettings /></AdminLayout>} />
                        <Route path="/admin/settings" element={<AdminLayout><Settings /></AdminLayout>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </div>
                  </Router>
                </ThemeProvider>
              </MenuProvider>
            </OrderProvider>
          </PrinterProvider>
        </PaymentProvider>
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;